import styled from 'styled-components';

const VendorBusinessDetailsFormStyledNew = styled.form`
    display: flex;
    height: 100%;
    .detailsContainer {
        margin-bottom: 80px;
        @media (min-width: 815px) {
            max-width: 100%;
            margin-bottom: 0px;
        }
    }

    @media (min-width: 815px) {
        .business-input-wrapper > div {
            flex: 0 0 32%;
        }

        .business-input-wrapper {
            justify-content: flex-start;
            gap: 2%;
        }
    }

    .addressLines > div {
        margin-top: 5px;
    }
    .websiteField {
        margin-top: 0px;
    }

    .is-invalid {
        background-color: rgba(253, 243, 243, 1);
        .p4 {
            color: rgba(222, 23, 23, 1);
        }
    }
    .pearl-error {
        font-size: 12px;
    }
    // .is-focused {
    //     border-color: black !important;
    // }
    .label {
        color: ${(props) => props.theme.colors.primary.base};
    }
    .tooltipEINNumber {
        display: inline-flex;
        position: absolute !important;
        right: 16px;
        top: 16px;
        .icon-info {
            width: 18px;
            height: 18px;
            font-size: 18px;
            &:before {
                width: 18px !important;
                height: 18px !important;
            }
        }
        z-index: 99;
    }
`;

export { VendorBusinessDetailsFormStyledNew };
